export default "__VITE_ASSET__CXgWdnls__"